<template>
  <div class="msgtypeImage">
    <img
      alt=""
      :src="items.cos_file_url"
      :class="proportion ? 'box_img1' : 'box_img2'"
      v-if="items.msgtype === 'image'"
    />
    <img alt="" :src="items.cos_file_url" :style="img_size" v-if="items.msgtype === 'emotion'" />
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      proportion: false,
      img_size: '',
    };
  },
  mounted() {
    const imgObj = new Image();
    imgObj.src = this.items.cos_file_url;
    imgObj.onload = () => {
      if (imgObj.width >= imgObj.height) {
        this.proportion = true;
      }
    };
    if (this.items.msgtype === 'emotion') {
      this.img_size =
        `width:${this.items.content.width}px` + `,height:${this.items.content.height}px`;
    }
  },
};
</script>

<style scoped lang="scss">
.msgtypeImage {
  border-radius: 8px;
  padding: 0 12px;
  box-sizing: border-box;
  .box_img1 {
    width: 442px;
    border-radius: 8px;
    font-size: 0;
  }
  .box_img2 {
    height: 244px;
    border-radius: 8px;
    font-size: 0;
  }
}
</style>
